import * as Styled from '../BusinessProcessTree.styled';
import { InfoButton } from './InfoButton';

export const renderGapNode = (node: any, level: number, token: any) => {
  const item = node.raw;

  const types = ['bru', 'gap', 'audit', 'solution'];

  return (
    <Styled.TreeNodeWrapper>
      <Styled.TreeLabel token={token}>
        {types[level].toUpperCase()}
      </Styled.TreeLabel>
      <Styled.TreeValue token={token} level={level}>
        {node.label}
        <InfoButton type={types[level] as any} item={item} />
      </Styled.TreeValue>
    </Styled.TreeNodeWrapper>
  );
};
